<template>
    <div id="app" :class="`${themeClassName} theme-campaign-light`">
        <Layout class="campaign-layout">
            <CampaignHeader :is-authorized-content-visible="isAuthorized" :has-campaign="false" />
            <Sider
                collapsible
                hide-trigger
                :model-value="!isSidebarOpen"
                :collapsed-width="sidebarWidthCollapsed"
                :width="sidebarWidthOpen"
            >
                <portal-target name="main-sidebar" />
            </Sider>
            <Layout class="campaign-content">
                <Content class="main-content">
                    <router-view
                        :key="$route.fullPath"
                        class="content-wrapper hox-full-height hox-full-width router-view"
                    />
                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script lang="ts">
import CampaignHeader from "@/CampaignHeader.vue";

import { defineComponent } from "vue";
import { useSidebar } from "@/composables/useSidebar";
import { useUser } from "@/composables/useUser";
import { useTheme } from "@/composables/useTheme";

export default defineComponent({
    name: "ThemeTemplatesLight",
    components: {
        CampaignHeader
    },

    setup() {
        const { isSidebarOpen, sidebarWidthCollapsed, sidebarWidthOpen, setSidebarWidthOpen } = useSidebar();
        const { isAuthorized } = useUser();
        const { themeClassName } = useTheme();

        setSidebarWidthOpen(250);

        return {
            themeClassName,
            isAuthorized,
            isSidebarOpen,
            sidebarWidthCollapsed,
            sidebarWidthOpen
        };
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.theme-campaign-light {
    .campaign {
        &-header {
            background-color: $cmp-light-bg-color;
            border-bottom: 1px solid $cmp-light-border-color;

            &__breadcrumb {
                span.inactive-link {
                    color: $cmp-light-secondary-font-color;
                }

                a {
                    color: $cmp-light-secondary-font-color;

                    &:hover {
                        color: $cmp-light-secondary-font-color;
                    }
                }
            }
        }

        &-banner {
            &-footer {
                color: $cmp-light-font-color;
            }
        }
    }

    .ivu-layout-sider {
        background-color: $white;

        .sidebar-body {
            width: $campaign-library-pane-width;
            top: 0;
            position: fixed !important;
            overflow: auto !important;
            height: 100vh;
        }
    }

    .main-content {
        background-color: $cmp-light-bg-color;
    }
}
</style>
